"use client";
import React from "react";
import { Scale, Mail, ArrowRight } from "lucide-react";

export default function TermsOfServicePage() {
  const appTitle = process.env.NEXT_PUBLIC_APP_TITLE;
  const contactEmail = process.env.NEXT_PUBLIC_APP_EMAIL;

  return (
    <div className="bg-gray-50 lg:py-7">
      <div className="max-w-4xl mx-auto py-10 sm:py-16 px-4 sm:px-6 lg:px-8 bg-white shadow-lg lg:rounded-xl">
        <div className="mb-4 border-b pb-4 border-gray-200">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-2">
            Terms of Service
          </h1>
        </div>

        <p className="text-base sm:text-lg text-gray-700 mb-8 lg:mb-7 leading-relaxed">
          These Terms of Service govern your use of <span className="font-semibold text-primary-600">{appTitle}</span>. By accessing or using our site, you agree to these terms.
        </p>

        <div className="bg-indigo-50 p-6 sm:p-8 rounded-lg mb-10 border border-indigo-100">
          <h2 className="text-xl font-bold text-indigo-800 mb-4 flex items-center">
            <Scale className="w-5 h-5 mr-2" />
            Your Agreement
          </h2>
          <ul className="list-disc pl-6 text-base text-gray-700 space-y-3">
            <li className="pl-1">Use the platform lawfully and respectfully.</li>
            <li className="pl-1">Offers and deals are subject to change and availability.</li>
            <li className="pl-1">We are not liable for third-party content or actions.</li>
            <li className="pl-1">Violation of terms may result in account suspension or termination.</li>
          </ul>
        </div>

        {/* Contact CTA */}
        <p className="text-base sm:text-lg text-gray-700 mt-10 pt-4 border-t border-gray-200 flex items-center space-x-2">
          <Mail className="w-5 h-5 text-gray-400" />
          <span>For questions, contact <a href={`mailto:${contactEmail}`} className="text-primary-600 font-semibold hover:text-primary-700 underline transition-colors">{contactEmail}</a>.</span>
        </p>
                <div className="mt-10 pt-4 border-t border-gray-200">
            <p className="text-base sm:text-lg text-gray-700 font-medium">
                For a complete understanding of your rights and obligations,
                <span className="block sm:inline mt-2 sm:mt-0 sm:ml-2">
                    <a 
                        href="/terms-of-use" 
                        className="flex items-center space-x-1 text-primary-600 font-semibold hover:text-primary-700 underline transition-colors w-max mx-auto sm:mx-0"
                    >
                        <span>Read our full Terms of Use</span>
                        <ArrowRight className="w-4 h-4"/>
                    </a>
                </span>
            </p>
        </div>
      </div>
    </div>
  );
}